import {useEffect, useState} from "react";
import {Button, Popconfirm, Space, Table} from "antd";
import {
    DownloadOutlined,
    LeftOutlined,
    RightOutlined,
    SearchOutlined, 
    UsergroupAddOutlined, DeleteOutlined, CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined
} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import Search from "antd/es/input/Search";
import {xcService} from "../../../../_services/xcService";
import variables from "../../../../_constants/variables";
import localOrSessionStore from "../../../../_helpers/localOrSessionStore";
import InviteUser from './invite'
import {useDispatch, useSelector} from "react-redux";

import { Excel } from "antd-table-saveas-excel";
import moment from "moment";

const TutorsView = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [sourceData, setSourceData] = useState([]);
    const [tableDataForm, setTableDataForm] = useState([]);
    const [selectedFormRowKeys, setSelectedFormRowKeys] = useState([]);
    const [showInviteUserModal, setShowInviteUserModal] = useState(false);
    const [currentUser, setCurrentUser] = useState(false);
    const [userProfile, setUserProfile] = useState();
    const [actualPage, setActualPage] = useState(1)
    const [courses, setCourses] = useState([]);
    const [columns, setColumns] = useState(null);

    var coursesData = useSelector((state) => state.dataReducer.coursesData);

    const onSearch = ({target}) => {
        let mSearch = target.value.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "")


        setTableData(mSearch === '' ? sourceData: sourceData.filter((item) => {
            return item.fullname.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").includes(mSearch)
                ||item.email.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").includes(mSearch)
        }))
    }

    const [currentTab, setCurrentTab] = useState(0);
    const userType = storage.getItem(variables.USER_TYPE);

    function onlyUnique(value, index, self) {
        return self?.indexOf(value) === index;
    }
;

    const columnsForm = [
        {
            title: t("tutores.informes.tableselect"),
            dataIndex: 'name',
            render: (text) => <p className={"text-data"}>{text}</p>,
        },
        {
            title: t("tutores.informes.tableyear"),
            dataIndex: 'year',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
        },
        {
            title: t("tutores.informes.tablecourse"),
            dataIndex: 'course',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
        },
    ];


    useEffect(() => {
        if (coursesData) {
            setCourses(coursesData);

            if (userType !== 'MASTER')
                xcService.getToken(userType === 'CENTER' ? '/v1/center/me' : '/v1/tutor/me/center').then(({data}) => {
                    setUserProfile(data.data)
                });
            getListado()
        }
    }, [coursesData]);


    const headersCsv = [
        { title: t("tutores.informes.tableename"), key: "fullname", dataIndex: "fullname" },
        { title: t("tutores.informes.tableemail"), key: "email", dataIndex: "email" },
        { title: t("tutores.informes.tabletelephone"), key: "phone", dataIndex: "phone" },
        { title: t("tutores.informes.tablecourse"), key: "courses", dataIndex: "courses" },

        { title: t("registro.nif"), key: "nif" , dataIndex: "nif"},
        { title: t("registro.gender"), key: "gender", dataIndex: "gender" },
        { title: t("registro.profesion"), key: "profession", dataIndex: "profession" },
        { title: t("tutores.informes.tablecenter"), key: "centerName" , dataIndex: "centerName"},
        { title: t("tutores.informes.tablecode"), key: "centerCode", dataIndex: "centerCode" }
    ];


    const exportXLS = () => {
        const excel = new Excel();
        excel
            .addSheet("tutors")
            .addColumns(headersCsv)
            .addDataSource(tableData, {
                str2Percent: true
            })
            .saveAs("tutorsExport" + moment().format(("YYYYMMDD")) + ".xlsx");
    }


    const getListado = () => {
        const tutorEndpoints = {
            'COUNSELOR': '/v1/counselor/tutors',
            'CENTER': '/v1/center/tutors',
            'MASTER': '/v1/master/tutors'
        }
        xcService.getToken(tutorEndpoints[userType])
            .then(({data})=>


                data.data.map(tutor=>{
                    return {
                        ...tutor,
                        fullname: tutor.name + ' ' + tutor.surname,
                        year: tutor.year + '/' + (tutor.year+1),
                        coursename: tutor.course?.name,
                        centerName: tutor.center?.name,
                        centerCode: tutor.center?.code,
                        state: tutor.validated ? t("validated") :  t("novalidated"),
                        courses: tutor.tutorgroups.map(cc =>  cc.course.name ).join(", ")
                    }
                }))
            .then(tutors=> {
                setTableData(tutors)
                setSourceData(tutors);

                var mCourses = [];
                coursesData.map((item) => {
                    mCourses.push({ text: item.name, value: item.id });
                });

                setColumns( [
                    {
                        title: t("tutores.informes.tableselect"),
                        dataIndex: 'fullname',
                        render: (text) => <p className={"text-data"}>{text}</p>,
                        sorter: (a, b) => a.fullname?.localeCompare(b.fullname)
                    },
                    {
                        title: t("tutores.informes.tableemail"),
                        dataIndex: 'email',
                        render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
                        sorter: (a, b) => a.email?.localeCompare(b.email)
                    },
                    {
                        title: t("tutores.informes.tabletelephone"),
                        dataIndex: 'phone',
                        render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
                        sorter: (a, b) => a.phone-b.phone
                    },


                    {
                        title: t("tutores.informes.tableyear"),
                        dataIndex: 'year',
                        render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
                        sorter: (a, b) => a.year?.localeCompare(b.year)
                    },
                    {
                        title: t("tutores.informes.tablecenter"),
                        dataIndex: 'centerName',
                        render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
                        sorter: (a, b) => a.centre - b.centre
                    },

                    {
                        title: t("tutores.informes.tablecode"),
                        dataIndex: 'centerCode',
                        render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
                        sorter: (a, b) => a.course?.localeCompare(b.centerCode),

                        filters: userType === 'ADMIN' ? tableData.map(data => data.centerCode)
                            .filter(onlyUnique)
                            .sort((a, b) => a?.localeCompare(b))
                            .map(centerCode => {
                                return {
                                    text: centerCode,
                                    value: centerCode
                                }
                            }) : null,
                        onFilter: (value, record) => {
                            return record.centerCode?.indexOf(value) === 0
                        },
                    },
                    {
                        title: t("tutores.informes.tablecourse"),
                        dataIndex: 'coursename',
                        render: (text, record) => <div>
                            {
                                record.tutorgroups ?
                                    record.tutorgroups.map(item => {
                                        return <p className={"text-data text-data--small"}
                                                  key={item.id}>{item.course.name}</p>
                                    })
                                    :  <p className={"text-data text-data--small"}>{text}</p>
                            }
                        </div>,
                        filters: coursesData.map(state=>{
                            return {
                                text: state.name,
                                value: state.id
                            }
                        }),
                        onFilter: (value, record) => {
                            return record.tutorgroups.filter(itc => itc.course_id === value).length > 0;
                        },
                    },

                    {
                        title: t("tutores.informes.tablestate"),
                        dataIndex: 'state',
                        render: (text, record) => {
                            if (record.validated) {
                                return <div style={{fontSize: '11px', color: '#389E0D'}}><CheckCircleOutlined
                                    style={{fontSize: '11px', fill: '#389E0D'}}/>{t("tutores.informes.validado")}</div>
                            } else {
                                return <div style={{fontSize: '11px', color: '#FFB81C'}}><ExclamationCircleOutlined
                                    style={{fontSize: '11px', fill: '#FFB81C'}}/>{t("tutores.informes.pendiente")}</div>
                            }
                        },
                        sorter: (a, b) => a.state?.localeCompare(b.state),
                        filters: [
                            {
                                text: t("validated"),
                                value: t("validated"),
                            },
                            {
                                text: t("novalidated"),
                                value: t("novalidated"),
                            },
                        ],
                        onFilter: (value, record) => {

                            return record.state?.indexOf(value) === 0
                        },
                    },
                    {
                        title: t("tutores.informes.tableviewtuor"),
                        key: 'view',
                        render: (_, record) => (
                            <Space size="middle">
                                <div className={"text-show-data"}><a onClick={()=>showTutor(record)}>{t("tutores.informes.view")} <RightOutlined /></a></div>
                            </Space>
                        ),
                    },
                ]);
            });


    }

    const showTutor = (item) => {

        setCurrentUser((item))
    }

    const validateTutor = (id) => {
           xcService.putToken(`/v1/tutor/auth/validate/${id}`).then(data => {
               setCurrentUser({...currentUser, validated: true})
               getListado()

           })
    }

    const deleteTutor = (id) => {
        xcService.deleteToken(`/v1/tutor/auth/delete/${id}`).then(data => {
            getListado();
            setCurrentUser(null)

        })
    }

    const desvinculaTutor = (id) => {
        xcService.putToken(`/v1/tutor/auth/unvalidate/${id}`).then(data => {
            setCurrentUser({...currentUser, validated: false})
            getListado()

        })
    }
    const onSelectFormChange = newSelectedRowKeys => {
        setSelectedFormRowKeys(newSelectedRowKeys);
    };

    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const rowSelectionForm = {
        selectedFormRowKeys,
        onChange: onSelectFormChange,
    };

    const copyLink = (link) => {
        navigator.clipboard.writeText(link)
    }


    const onChangePage = (pageNumber) => {
        setActualPage(pageNumber.current);
        localStorage.setItem("TUTORPAGE", pageNumber.current);
    };

    const goBack = () => {
        let mPage = 1;
        if (localStorage.getItem("TUTORPAGE")){
            mPage = +localStorage.getItem("TUTORPAGE")
        }
       setActualPage(mPage);
        setCurrentUser(null)

    }



    const deletetutor = (id) => {
        xcService.deleteToken(
            `/v1/${userType === "MASTER" ? 'master/tutors' : 'tutor/auth/delete'}/${id}`).then(data => {
            getListado();
            setCurrentUser(null)
        })
    }


    const activateTutor = (id) => {

        xcService.putToken( `/v1/${userType === "MASTER" ? 'master/tutors/validate' : 'tutor/auth/validate'}/${id}`).then(data => {
            getListado();
            setCurrentUser(null)
        })
    }


    return (
        <>
        {showInviteUserModal &&
            <InviteUser t={t} type={"tutor"}
                        link={"/tutorAuth/register"}
                        userProfile={userProfile} showInviteUserModal={showInviteUserModal} setShowInviteUserModal={setShowInviteUserModal} />
        }


            {!currentUser&&<div>
                <div className={"informes-header"}>
                    <div className={"informes-header__top"}>
                        <h1 className={"is-first"}>{t("tutores.list.title")}</h1>
                        <Button className={"btnWhiteBlue"}
                                onClick={() => setShowInviteUserModal(true)}><UsergroupAddOutlined/>{t("alumnos.familyButton")}
                        </Button>
                    </div>
                    {userType === 'CENTER' &&
                        <>
                            <p>{t("lusers.centertutor")}</p>
                            <p>{t("lusers.centersubtutor")}</p>
                        </>
                    }
                    {userType === 'COUNSELOR' &&
                        <>
                            <p>{t("lusers.orientatutor")}</p>
                            <p>{t("lusers.oriensubtatutor")}</p>
                        </>
                    }
                    {userType === 'MASTER' &&
                        <p>{t("tutores.informes.subtitletutor")}</p>
                    }
                    <div className={"informes-header__bottom"}>
                        <div className={"informes-header__bottom-left"}>
                            <Search
                                placeholder={t("tutores.informes.search")}
                                allowClear
                                enterButton={<SearchOutlined/>}
                                size="large"
                                onChange={onSearch}
                            />
                        </div>
                        <div className={"informes-header__bottom-right"}>
                                <Button onClick={exportXLS} className={"btnWhiteBlue"}><DownloadOutlined/>{t("tutores.informes.downloadButton")}
                                </Button>

                        </div>
                    </div>
                </div>
                <div className={"report-table"}>

                    {columns && columns[0] &&
                    <Table onChange={onChangePage} rowKey={"id"} pagination={{current: actualPage, position: ['bottomCenter']}} rowSelection={rowSelection} columns={columns}
                           dataSource={tableData}/> }
                </div>
            </div>}
            {currentUser&&<div>
                <div className={"informes-header"}>
                    <a className={"informes-header__back"} onClick={()=>goBack()}><LeftOutlined /> {t("backtolist")}</a>
                    <div className={"informes-header__top"}>
                        <h1>{t("tutores.tutor.title")}</h1>
                    </div>
                    <div className={"cardStudent cardStudent--max-width"}>

                        <div className={"itemCard itemCardHeader"}>{t("informes.card.title")}</div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tableename")}:</div><div className={"itemCardRight"}>{currentUser.name}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tablesurename")}:</div><div className={"itemCardRight"}>{currentUser.surname}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tableemail")}:</div><div className={"itemCardRight"}>{currentUser.email}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tablenif")}:</div><div className={"itemCardRight"}>{currentUser.nif??'77777777A'}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tabledegree")}:</div><div className={"itemCardRight"}>{currentUser.profession}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tablecenter")}:</div><div className={"itemCardRight"}>{currentUser.centerName.replaceAll("&quot;","")}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tabledirector")}:</div><div className={"itemCardRight"}>{currentUser.center?.directorName} {currentUser.center?.directorSurname}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tableyear")}:</div><div className={"itemCardRight"}>{currentUser.year}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tablecourse")}:</div><div className={"itemCardRight"}>{
                            currentUser?.tutorgroups.map(item => {
                                return <div className={"itemCardRight"}
                                            key={item.id}>{item.course.name} ({t("login.group")} {item.group})</div>
                            })
                            }</div></div>
                    </div>
                    <div className={"container--informes--buttons"}>

                        {currentUser.validated ?
                            <>
                                <Popconfirm  onConfirm={() => deletetutor(currentUser.id)}
                                             title={t("estaseguro")}
                                             okText={t("yes")}
                                             cancelText="No"
                                >
                                    <Button className={"btnWhiteBlue"}><DeleteOutlined />{t("tutores.alumno.unlink")}</Button></Popconfirm>
                            </>
                            :<div style={{display: "flex", flexDirection: "row"}}>
                                
                                
                                <Popconfirm  onConfirm={() => activateTutor(currentUser.id)}
                                             title={t("segurovalidar")}
                                             okText={t("yes")}
                                             cancelText="No"
                                >
                                    <Button  className={"btnWhiteBlue"}><CheckCircleOutlined />{t("tutores.tutor.validate")}</Button></Popconfirm>&nbsp;&nbsp;
                                <Popconfirm  onConfirm={() => deletetutor(currentUser.id)}
                                             title={t("estaseguro")}
                                             okText={t("yes")}
                                             cancelText="No"
                                ><Button className={"btnWhiteBlue"}><CloseCircleOutlined />{t("tutores.tutor.reject")}</Button></Popconfirm>
                            </div>}
                    </div>
                </div>
            </div>}
</>
    )
}

export default TutorsView;
